module.exports = __webpack_public_path__ + "img/icono-footer-2.92ce7c1d.svg";